/* src/app/_shared/components/back-button/back-button.component.scss */
:host {
  z-index: 10000;
}
ion-back-button {
  --color: var(--ion-color-secondary-shade);
  --color-focused: var(--ion-color-secondary-shade);
  --color-hover: var(---ion-color-secondary-shade);
  --background-focused: var(--ion-color-light);
  --background-hover: var(--ion-color-light);
  --min-height: 32px;
  --min-width: 26px;
  --padding-start: calc(var(--space-left) / 2);
  --padding-end: calc(var(--space-right) / 2);
  border-radius: var(--radius);
  z-index: 10000;
}
ion-back-button::part(text) {
  font-size: 16px;
}
ion-back-button.ion-activated {
  opacity: 1;
  color: var(--ion-color-primary);
  background-color: var(--ion-color-light);
}
/*# sourceMappingURL=back-button.component.css.map */
